/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDetail401kRate.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/detail-401k-rate";

export class AutogenModelDetail401kRate<RowType extends ModelRow> extends Endpoint<RowType, RowDetail401kRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDetail401kRate extends ModelRow<RowDetail401kRateFields> {
	constructor(values?: Partial<RowDetail401kRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDetail401kRateFields {
	company_id: string;
	fund_id: string;
	id: string;
	match_amount: number;
	match_amount_c: string;
	match_amount_d: Date;
	match_amount_n: number;
	match_amount_r: number;
	match_percent: number;
	payee_amount: number;
	payee_amount_c: string;
	payee_amount_d: Date;
	payee_amount_n: number;
	payee_amount_r: number;
	payee_id: string;
	payee_percent: number;
	sequence: number;
}

